export default vm => {
    return vm.$riDataProvider
        .get('permissions')
        .then(permissions => permissions.map(({ id }) => id))
        .catch(() => []);
};
